export const BUSINESS_CATEGORIES = [
  { name: "Groceries", code: "52045411" },
  { name: "Fashion", code: "52045631" },
  { name: "Automotive", code: "52045533" },
  { name: "Babies / Kids / Mommies", code: "52045641" },
  {
    name: "Electronic Sales, Electronic Store, Music Store ",
    code: "52045732",
  },
  { name: "Event", code: "52047999" },
  { name: "Financial Service", code: "52046012" },
  { name: "Hotel & Resorts", code: "52047011" },
  { name: "Medical Service", code: "52048011" },
  { name: "OTA / Travel Package", code: "52044722" },
  { name: "Shipping & Delivery Service", code: "52044215" },
  { name: "Stationery", code: "52045943" },
  { name: "Beauty Service", code: "52047298" },
  { name: "Advertising", code: "52047311" },
  { name: "Auction", code: "52048999" },
  { name: "Books / Magazine", code: "52045942" },
  { name: "Cable & Streaming Service", code: "52044899" },
  { name: "Charity & Donation", code: "52048398" },
  { name: "College & School", code: "52048220" },
  { name: "Beauty Products", code: "52047230" },
  { name: "Digital Content", code: "52045815" },
  { name: "Education Services", code: "52048299" },
  { name: "Flowers", code: "52045992" },
  { name: "Food & Beverage", code: "52045499" },
  { name: "Home, Furniture & Appliances", code: "52045712" },
  { name: "Gaming", code: "52045816" },
  { name: "Hobbies, Toys & Craft", code: "52045945" },
  { name: "Insurance", code: "52046300" },
  { name: "Marketplace", code: "52047278" },
  { name: "Medical Supplies & Equipment", code: "52045047" },
  { name: "Pet Supplies", code: "52045995" },
  { name: "Property Developer", code: "52041520" },
  { name: "Pulsa / PPOB", code: "52044814" },
  { name: "Real Estate Rent", code: "52046513" },
  { name: "Religious Goods", code: "52045973" },
  { name: "Investment", code: "52046211" },
  { name: "Software", code: "52045734" },
  { name: "Sport", code: "52047941" },
  { name: "Transportation", code: "52044789" },
  { name: "Voucher", code: "52045310" },
  { name: "Watches & Jewelry", code: "52045094" },
  { name: "Drug Stores & Pharmacies", code: "52045912" },
  { name: "Consulting", code: "52047392" },
  { name: "Printing", code: "52042741" },
  { name: "Raw Materials", code: "52045039" },
  { name: "Lifestyle / Entertainment", code: "52047929" },
  { name: "Home Services", code: "52045722" },
  { name: "Web App Developer / Hosting", code: "52047372" },
  { name: "Machinery", code: "52045085" },
];
